import { gql } from '@urql/core';

export const RecommendationsFragment = gql`
	fragment RecommendationsFragment on GrowthUnifiedProfileAccountProfileResult {
		recommendations {
			nbp {
				key
				values
			}
		}
	}
`;
